import {resaveConsentCookie, setConsentCookie, saveSettingsToBrowser, existsConsentCookie, getConsentCookie} from './consent';
import {openLoggedDialog, openUnloggedDialog} from './dialog';
import {setPrefilledFormData, setFormDataLoggedInUser, setFormDataFromConsent} from './formData';
import {setCookieToGlobalStorage, getCookieFromGlobalStorage} from './globalCookie';
import {logger} from './logger';
import {getProfileError, clearProfileError, existsProfileError, handleProfileError, isProfileCookieOutdated} from './profil';
import {MISSING_CONSENT, CMP_DATE, SZN_SETTING_PAGES} from '../constants';
import {checkForUpdate, checkNoOpenInterval} from '../utils/checks';
import {currentHost} from '../utils/host';
import {config} from './measurement';

export const userNoConsentCookie = async userType => {
  try {
    const cookieGlobal = await getCookieFromGlobalStorage(userType);

    logger(700, 'Found cookie in global - synchronize it.');
    setConsentCookie(cookieGlobal);
  } catch (e) {
    logger(701, 'No euconsent cookie found in global');
    if (checkNoOpenInterval()) {
      openUnloggedDialog(MISSING_CONSENT, userType);
    }
  }
};

export const userHasConsentCookie = async userType => {
  try {
    const cookieGlobal = await getCookieFromGlobalStorage(userType);

    if (checkForUpdate(cookieGlobal)) {
      logger(702, 'Found newer cookie in global - synchronize it.');
      setConsentCookie(cookieGlobal);
    } else {
      logger(703, 'Local cookie is already the newest version.');
      resaveConsentCookie();
    }
  } catch (e) {
    logger(704, 'No euconsent cookie found in global. Finished.');
  }
};

export const signedUserHasConsentCookie = (profileData, userType) => {
  logger(705, 'Euconsent already exists in Profile.');

  if (existsProfileError()) {
    clearProfileError();
  }

  if (isProfileCookieOutdated(profileData.euconsent.created, CMP_DATE)) {
    logger(706, 'Euconsent in browser is outdated.');
    if (checkNoOpenInterval()) {
      openLoggedDialog(profileData, userType);
    }
    return;
  }

  const profileCookie = profileData.euconsent.encodedCookie;

  if (profileCookie === getConsentCookie()) {
    logger(707, 'Everything is up to date. No work needed.');
    resaveConsentCookie();
    return;
  }

  logger(708, 'Browser euconsent cookie will be rewrited with Profile cookie.');
  saveSettingsToBrowser(profileCookie);

  //store to ssp localhost, because unlogged user on other pages
  setCookieToGlobalStorage(profileCookie, userType);
};

export const signedUserNoConsentCookie = (profileData, userType) => {
  logger(709, 'Euconsent was not found in Profile.');

  if (existsProfileError()) {
    logger(710, 'ProfileError: data exists.');
    const data = getProfileError();

    if (data.rusId === profileData.rusId) {
      logger(711, 'ProfileError: rusId is same.');
      handleProfileError(data.euconsent);
      return;
    }

    logger(712, 'ProfileError: different rusId.');
  }

  if (checkNoOpenInterval()) {
    setFormDataLoggedInUser(profileData);
    openLoggedDialog(profileData, userType);
  }
};

export const openImmediately = userType => async () => {
  logger(713, 'Dialog was initializated with click.');
  config(userType);

  if (SZN_SETTING_PAGES.includes(currentHost)) {
    logger(714, 'Opening dialog on setting page.');
    try {
      const cookieGlobal = await getCookieFromGlobalStorage(userType);
      logger(715, 'Found cookie in global, set consent from it.');
      setFormDataFromConsent(cookieGlobal);
    } catch (error) {
      logger(716, 'No euconsent cookie found in global, set default values');
    }
    openUnloggedDialog(MISSING_CONSENT, userType);
    return;
  }

  if (existsConsentCookie()) {
    setPrefilledFormData();
  }

  openUnloggedDialog(MISSING_CONSENT, userType);
};
